<template>
  <div>
    <v-form
      v-model="valid"
      ref="form"
      lazy-validation
      class="pa-4 px-4"
      @submit.prevent="updateCategory"
      v-if="category"
    >
      <v-container>
        <div class="d-flex justify-end">
          <v-btn
            tile
            color="primary"
            @click="$router.push({ name: 'category-index' })"
          >
            <v-icon left>
              arrow_back
            </v-icon>
            Back
          </v-btn>
        </div>
        <v-row class="mb-2">
          <v-col offset-lg="4" cols="4" class="text-center">
            <v-text-field
              :counter="35"
              label="Name"
              v-model="category.name"
              :rules="nameRules"
            ></v-text-field>

            <v-textarea
              :counter="200"
              label="Description"
              :rules="descriptionRules"
              v-model="category.description"
              required
            ></v-textarea>
            <v-btn type="submit" class="mx-0 mt-4">Update</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-row>
      <v-col sm="12" md="6">
        <SubcategoryList
          module="categories/LOAD_SUBCATEGORIES"
          :actions="false"
          :payload="{ from: 0, to: 10, categoryId: id }"
        />
      </v-col>
      <v-col sm="12" md="6">
        <ProductList
          module="categories/LOAD_PRODUCTS"
          :actions="false"
          :showFilters="false"
          :payload="{ from: 0, to: 10, categoryId: id }"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapState } from "vuex";
import SubcategoryList from "@/components/subcategory_management/SubcategoryList.vue";
import ProductList from "@/components/product_management/ProductList.vue";
export default {
  props: ["id"],
  components: {
    SubcategoryList,
    ProductList
  },
  data() {
    return {
      valid: false,
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length >= 3) || "Name must be at least 3 characters",
        v =>
          (v && v.length <= 35) || "Name must be less than than 35 characters"
      ],
      descriptionRules: [
        v => !!v || "Description is required",
        v =>
          (v && v.length >= 3) || "Description must be at least 3 characters",
        v =>
          (v && v.length <= 200) ||
          "Description must be less than than 200 characters"
      ]
    };
  },
  mounted() {
    this.$store.dispatch("categories/LOAD_CATEGORY", {
      categoryId: this.id
    });
    this.$store.dispatch("categories/LOAD_PRODUCTS", {
      categoryId: this.id,
      from: 0,
      to: 10
    });
  },
  computed: {
    ...mapState({
      countries: state => state.countries.countries,
      category: state => state.categories.category
    })
  },
  methods: {
    async updateCategory() {
      if (this.$refs.form.validate()) {
        this.$swal({
          title: "Updating category...",
          html: "this will only take a moment...",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("categories/UPDATE_CATEGORY", this.category);
        this.$swal.close();
        this.$swal({
          title: "Success",
          html: "Category has been updated",
          icon: "info"
        });
      }
    }
  }
};
</script>
